export default __webpack_public_path__ + "static/media/5.db0998ce.jpg";